/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewSetting } from '../models/NewSetting';
import type { Settings } from '../models/Settings';
import type { UpdateSetting } from '../models/UpdateSetting';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SettingsControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody Change active tournament id
     * @returns Settings Active tournament setting updated successfully.
     * @throws ApiError
     */
    public settingsControllerUpdateActiveTournament(
        requestBody?: {
            tournamentId: number;
        },
    ): CancelablePromise<Settings> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/settings/active-tournament',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param key
     * @param requestBody Update setting
     * @returns Settings Updated Settings model instance.
     * @throws ApiError
     */
    public settingsControllerAdminUpdateSetting(
        key: string,
        requestBody?: UpdateSetting,
    ): CancelablePromise<Settings> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/settings/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param key
     * @returns Settings Settings model instance.
     * @throws ApiError
     */
    public settingsControllerAdminGetSetting(
        key: string,
    ): CancelablePromise<Settings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/settings/{key}',
            path: {
                'key': key,
            },
        });
    }
    /**
     * @param key
     * @returns void
     * @throws ApiError
     */
    public settingsControllerAdminDeleteSetting(
        key: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/settings/{key}',
            path: {
                'key': key,
            },
        });
    }
    /**
     * @param requestBody Create new setting
     * @returns Settings Created Settings model instance.
     * @throws ApiError
     */
    public settingsControllerAdminCreateSetting(
        requestBody?: NewSetting,
    ): CancelablePromise<Settings> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Settings Array of Settings model instances.
     * @throws ApiError
     */
    public settingsControllerAdminListSettings(): CancelablePromise<Array<Settings>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/settings',
        });
    }
    /**
     * @returns Settings Prize money for the ladder competition.
     * @throws ApiError
     */
    public settingsControllerGetSystemSettings(): CancelablePromise<Array<Settings>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/settings/system',
        });
    }
}
